import React, { useMemo } from "react";

function parseRubyContent(
  content: string,
  highlightWord: string | undefined,
): React.ReactNode[] {
  const regex = /(<ruby>.*?<\/ruby>)/g;
  const parts = content.split(regex);

  return parts.map((part, index) => {
    if (part.startsWith("<ruby>")) {
      const match =
        /<ruby>(.*?)<rp>\((.*?)<\/rp><rt>(.*?)<\/rt><rp>(.*?)<\/rp><\/ruby>/.exec(
          part,
        );

      if (match) {
        const [, base, , reading] = match;
        return (
          <ruby key={index}>
            {base === highlightWord ? (
              <span className="text-primary font-bold">{base}</span>
            ) : (
              base
            )}
            <rp>(</rp>
            <rt>{reading}</rt>
            <rp>)</rp>
          </ruby>
        );
      }
    }
    return part;
  });
}

export function useRubyContent(
  content?: string | null,
  highlightWord?: string,
) {
  return useMemo(
    () => (content ? parseRubyContent(content, highlightWord) : undefined),
    [content, highlightWord],
  );
}
